import { Typography, theme } from 'antd';
import type { ComponentProps } from 'react';

/**
 * Chú thích cỡ nhỏ: chữ phụ, 12px (`fontSizeSM`) — ngày đăng dưới tiêu đề, dòng «tính trên n video» dưới
 * con số, ghi chú cạnh bộ lọc… Dùng nó thay cho `style={{ fontSize: 12 }}` để cỡ chữ luôn đi theo thang
 * chữ của app (`app/theme-tokens.ts`). `type` đổi được (vd. `danger`), mặc định là chữ phụ.
 */
export function Caption({ style, ...props }: ComponentProps<typeof Typography.Text>) {
  const { token } = theme.useToken();
  return (
    <Typography.Text type="secondary" {...props} style={{ fontSize: token.fontSizeSM, ...style }} />
  );
}
